import React from 'react';

import { TextField, useRecordContext } from 'react-admin';

import { get, isEmpty, keyBy } from 'lodash';

import { Typography } from '@mui/material';

import Answer from '../Answer';

import { Languages } from '../../../../constants/languages';
import conflictFields from '../../../../constants/conflictFields';
import { SourceOfWealthParameters } from '../../questionParameters';

export type SourceOfWealthFormAnswer = {
  options: string[];
  other?: string;
};

const ValueField = ({
  extraParameters,
}: {
  extraParameters?: SourceOfWealthParameters;
  language?: Languages;
}) => {
  const record = useRecordContext<{
    value: SourceOfWealthFormAnswer;
    sx?: any;
  }>();

  if (!record) return null;

  const options = get(record, 'value.options');
  const other = get(record, 'value.other');
  const sx = get(record, 'sx', {});

  if (isEmpty(options)) return <Typography>-</Typography>;

  const mapFields = keyBy(
    extraParameters?.options?.map((option) => ({
      id: option.id,
      name: extraParameters.choiceLabels?.[option.id] ?? option.label,
    })),
    'id',
  );

  const mappedValues = options?.map((v: string) => get(mapFields, v, { name: v }).name);
  if (other) mappedValues.push(other);

  const value = mappedValues.join(', ');

  return <TextField record={{ value }} sx={sx} source="value" emptyText="-" fontWeight="bold" />;
};

const SourceOfWealth = ({
  extraParameters,
}: {
  extraParameters?: SourceOfWealthParameters;
}) => (
  <Answer
    label={extraParameters?.label ?? ''}
    source="sourceOfWealth"
    datapoint={conflictFields.SOURCE_OF_WEALTH}
    identificationInfo={undefined}
  >
    <ValueField extraParameters={extraParameters} />
  </Answer>
);

SourceOfWealth.ValueField = ValueField;

export default SourceOfWealth;
